import ActivityCardBackground from './ActivityCardBackground'
import CalendarEventLink from './CalendarEventLink'
import { Text } from './Text'

export interface Activity {
  title: string
  startTime: string
  endTime: string
  dayOfWeek: string
  hall: string
  location: string
  address: string
}

interface Props {
  title?: string
  activities: Activity[]
}

export default function ActivityCard({ title, activities }: Props) {
  const isSunday = title?.toLowerCase() === 'sunday'
  const backgroundColor = isSunday ? 'bg-[#6A0429]' : 'bg-[#31183F]'
  return (
    <div className='flex flex-1 h-[527px] md:h-[260px] lg:h-[527px] max-h-[487px] lg:max-h-[470px] lg:max-w-[380px]  xl:max-h-[500px] xl:max-w-[400px] items-start rounded-3xl drop-shadow-sm transition-all overflow-hidden'>
      <div
        className={`relative flex h-full w-full flex-shrink-0 flex-col md:flex-row lg:flex-col gap-0 md:gap-auto p-11 lg:items-center gap-y-[44px] overflow-clip rounded-3xl border border-solid border-x-black/5 border-y-black/5 ${backgroundColor} text-center tracking-[0px] text-white`}
      >
        <ActivityCardBackground />
        <Text.H5 className='md:w-32 overflow-hidden lg:w-auto pt-0 lg:pt-0 block text-white/70'>
          {title}
        </Text.H5>
        {activities.map((activity, index) => {
          return (
            <div
              key={index}
              className='flex flex-col items-center md:items-start lg:items-center gap-y-1'
            >
              <Text.H4>{activity.title}</Text.H4>
              <CalendarEventLink
                eventTitle={activity.title}
                eventDetails={`${activity.title} at ${activity.startTime} to ${activity.endTime} organized by The Brethren Assembly, Dubai. For more information visit our website https://dubaibrethren.com or contact us at info@dubaibrethren.com`}
                location={[activity.hall, activity.location, activity.address].join(', ')}
                startTime={activity.startTime}
                endTime={activity.endTime}
                dayOfWeek={activity.dayOfWeek}
                className='text-white'
              />
              <Text.Body className='text-center md:text-left lg:text-center w-full md:w-60 text-white/80'>
                <p>{activity.hall},</p>
                <p>{activity.location}</p>
              </Text.Body>
            </div>
          )
        })}
      </div>
    </div>
  )
}
